import { render, staticRenderFns } from "./TasksGanttChart.vue?vue&type=template&id=68f9fde0&scoped=true"
import script from "./TasksGanttChart.vue?vue&type=script&lang=js"
export * from "./TasksGanttChart.vue?vue&type=script&lang=js"
import style0 from "./TasksGanttChart.vue?vue&type=style&index=0&id=68f9fde0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f9fde0",
  null
  
)

export default component.exports